<script setup lang="ts">
definePage({
  redirect: '/upgrade/account',
  meta: {
    permissionResource: 'Lead',
    shell: {
      showLeadPromotion: false,
    },
  },
})
</script>

<template>
  <div />
</template>
